module.exports = {

	methods: {
		promtSave: function(returnFunction, customData) {
			
			var self = this;	

			// Force
			var force = false;

			// Standard texts
			var message = self.$t('unsavedChanges');
			var title = self.$t('wantToContinue')

			if(typeof customData != 'undefined' && typeof customData.message != 'undefined')
				message = customData.message

			if(typeof customData != 'undefined' && typeof customData.title != 'undefined')
				title = customData.title

			if(typeof customData != 'undefined' && typeof customData.checkPictureWall != 'undefined')
			{
				if(self.$store.state.pictureWall == 0)
					force = true;
			}

			// If updated, fire promt
			if(self.$store.state.updated && !force)
			{
				window.eventHub.$emit('openModal', 
			    { 
			        modal: 'message', 
			        data: { 
			          title: title, 
			          messageClass: "longtext", 
			          message: message,
			          confirm: true,
			          confirmTxt: self.$t('save'),
			          declineTxt: self.$t('dontSave'),
			          abortTxt: self.$t('abort'),
			          primaryButton: 'confirm',

			          // User wants to save, do that instead
			          onConfirm(){
			          	window.eventHub.$emit('openModal', {modal: 'save' });
			          },

			          // User does not want to save
			          onDecline(){
			          	window.eventHub.$emit('closeModal');
			            returnFunction();
			          },

			          onAbort(){
			          	window.eventHub.$emit('closeModal');
			          }
			        } 
			    });
			}

			// If not, just continue
			else
				returnFunction();
		}
	}
};


// WEBPACK FOOTER //
// ./client/mixins/savePromt.js